import React from 'react'

import styles from './Footer.module.css'

function Footer() {
    return (
        <div className={styles.container}>
            <p>Copyright &copy; 2022</p>
            <p>@ML9FORCES</p>
        </div>
    )
}

export default Footer
